import { cfoTranslations } from "./cfoFraccionalTranslations";

export const EMPRESAS_LANG_STORAGE_KEY = "empresas-lang";

const gestionAportesEs = {
  slug: "gestion-aportes",
  eyebrow: "Empresas · Beneficios",
  titulo: "Gestión de aportes",
  subtitulo:
    "Centralice cotizaciones pensionales, cumplimiento normativo y seguimiento de aportes corporativos en una sola plataforma.",
  descripcion:
    "Estamos construyendo una solución fintech para que su empresa administre aportes a pensión con trazabilidad, alertas automáticas y reportes listos para nómina — sin fricción operativa.",
  progreso: 45,
  faseActual: "Desarrollo de módulos core",
  navItems: [
    { label: "Visión", targetId: "vision" },
    { label: "Funcionalidades", targetId: "funcionalidades" },
    { label: "Roadmap", targetId: "roadmap" },
    { label: "Contacto", targetId: "contacto" },
  ],
  highlights: [
    { valor: "100%", etiqueta: "Digital", detalle: "Sin papeles ni reprocesos manuales" },
    { valor: "24/7", etiqueta: "Monitoreo", detalle: "Alertas de vencimientos y novedades" },
    { valor: "1", etiqueta: "Panel único", detalle: "Visibilidad para RRHH y finanzas" },
  ],
  funcionalidades: [
    {
      key: "cotizacion",
      titulo: "Cotización inteligente",
      texto: "Simule y compare escenarios de aportes pensionales según plantilla, salarios y régimen aplicable.",
    },
    {
      key: "cumplimiento",
      titulo: "Cumplimiento normativo",
      texto: "Validaciones automáticas para reducir riesgos de incumplimiento ante entidades de control.",
    },
    {
      key: "colaborador",
      titulo: "Gestión por colaborador",
      texto: "Historial individual de aportes, novedades y documentación asociada a cada integrante del equipo.",
    },
    {
      key: "alertas",
      titulo: "Alertas proactivas",
      texto: "Notificaciones de fechas límite, inconsistencias de nómina y cambios regulatorios relevantes.",
    },
  ],
  roadmap: [
    { fase: "Investigación", estado: "completado", detalle: "Levantamiento con empresas y validación de flujos reales." },
    { fase: "Diseño UX/UI", estado: "completado", detalle: "Prototipos de panel corporativo y experiencia de cotización." },
    { fase: "Desarrollo", estado: "activo", detalle: "Integración de reglas pensionales y motor de alertas." },
    { fase: "Piloto empresarial", estado: "pendiente", detalle: "Pruebas controladas con empresas aliadas de MEU." },
    { fase: "Lanzamiento", estado: "pendiente", detalle: "Disponibilidad general para clientes Empresas." },
  ],
  whatsapp:
    "https://wa.me/573213213635?text=Hola%2C%20me%20interesa%20conocer%20m%C3%A1s%20sobre%20Gesti%C3%B3n%20de%20aportes%20para%20empresas%20cuando%20est%C3%A9%20disponible.",
  whatsappLabel: "Quiero ser contactado",
};

const gestionAportesEn = {
  slug: "gestion-aportes",
  eyebrow: "Business · Benefits",
  titulo: "Contribution management",
  subtitulo:
    "Centralize pension contributions, regulatory compliance, and corporate contribution tracking in one platform.",
  descripcion:
    "We are building a fintech solution so your company can manage pension contributions with traceability, automated alerts, and payroll-ready reports — without operational friction.",
  progreso: 45,
  faseActual: "Core module development",
  navItems: [
    { label: "Vision", targetId: "vision" },
    { label: "Features", targetId: "funcionalidades" },
    { label: "Roadmap", targetId: "roadmap" },
    { label: "Contact", targetId: "contacto" },
  ],
  highlights: [
    { valor: "100%", etiqueta: "Digital", detalle: "No paper or manual rework" },
    { valor: "24/7", etiqueta: "Monitoring", detalle: "Deadline and update alerts" },
    { valor: "1", etiqueta: "Single panel", detalle: "Visibility for HR and finance" },
  ],
  funcionalidades: [
    {
      key: "cotizacion",
      titulo: "Smart quoting",
      texto: "Simulate and compare pension contribution scenarios by headcount, salaries, and applicable regime.",
    },
    {
      key: "cumplimiento",
      titulo: "Regulatory compliance",
      texto: "Automated validations to reduce compliance risk with supervisory entities.",
    },
    {
      key: "colaborador",
      titulo: "Per-employee management",
      texto: "Individual contribution history, updates, and documentation for each team member.",
    },
    {
      key: "alertas",
      titulo: "Proactive alerts",
      texto: "Notifications for deadlines, payroll inconsistencies, and relevant regulatory changes.",
    },
  ],
  roadmap: [
    { fase: "Research", estado: "completado", detalle: "Discovery with companies and validation of real workflows." },
    { fase: "UX/UI design", estado: "completado", detalle: "Corporate panel prototypes and quoting experience." },
    { fase: "Development", estado: "activo", detalle: "Pension rules integration and alert engine." },
    { fase: "Business pilot", estado: "pendiente", detalle: "Controlled testing with MEU partner companies." },
    { fase: "Launch", estado: "pendiente", detalle: "General availability for Business clients." },
  ],
  whatsapp:
    "https://wa.me/573213213635?text=Hello%2C%20I%27d%20like%20to%20learn%20more%20about%20Contribution%20Management%20for%20businesses%20when%20it%27s%20available.",
  whatsappLabel: "Contact me",
};

const productoProximamenteUi = {
  es: {
    enDesarrollo: "En desarrollo",
    disponibleProximamente: "Disponible próximamente",
    avanceProducto: "Avance del producto",
    visionLabel: "Visión del producto",
    visionTitle: "Tecnología financiera pensada para equipos corporativos",
    visionExtra:
      "Este módulo forma parte de la hoja de ruta de MEU Aliado Empresas. Lo estamos desarrollando con enfoque fintech: datos confiables, procesos automatizados y una experiencia clara para finanzas, nómina y dirección.",
    featuresLabel: "Qué podrá hacer",
    featuresTitle: "Funcionalidades previstas",
    featuresNote:
      "Vista anticipada de capacidades en construcción. El alcance final puede ajustarse según retroalimentación de empresas piloto.",
    roadmapLabel: "Roadmap",
    roadmapTitle: "Hoja de ruta de lanzamiento",
    etapa: "Etapa",
    estados: { completado: "Completado", activo: "En curso", pendiente: "Próximo" },
    earlyAccess: "Acceso anticipado",
    contactTitle: "¿Le interesa ser de los primeros en probarlo?",
    contactBody:
      "Escríbanos y lo incluimos en la lista de contacto para pilotos y lanzamiento. Mientras tanto, explore los productos Empresas que ya están disponibles.",
    volverEmpresas: "Volver a Empresas",
    yaDisponible: "Ya disponible",
    productosDisponibles: [
      { titulo: "Dirección de innovación financiera", path: "/empresas/direccion-de-innovacion-financiera" },
      { titulo: "Gestión de caja", path: "/empresas/gestion-de-caja" },
      { titulo: "Sueldo Inteligente", path: "/sueldo-inteligente" },
    ],
  },
  en: {
    enDesarrollo: "In development",
    disponibleProximamente: "Coming soon",
    avanceProducto: "Product progress",
    visionLabel: "Product vision",
    visionTitle: "Financial technology built for corporate teams",
    visionExtra:
      "This module is part of the MEU Aliado Business roadmap. We are building it with a fintech focus: reliable data, automated processes, and a clear experience for finance, payroll, and leadership.",
    featuresLabel: "What you'll be able to do",
    featuresTitle: "Planned features",
    featuresNote:
      "Preview of capabilities under construction. Final scope may adjust based on pilot company feedback.",
    roadmapLabel: "Roadmap",
    roadmapTitle: "Launch roadmap",
    etapa: "Stage",
    estados: { completado: "Completed", activo: "In progress", pendiente: "Up next" },
    earlyAccess: "Early access",
    contactTitle: "Interested in being among the first to try it?",
    contactBody:
      "Message us and we'll add you to the pilot and launch contact list. In the meantime, explore Business products already available.",
    volverEmpresas: "Back to Business",
    yaDisponible: "Available now",
    productosDisponibles: [
      { titulo: "Financial innovation leadership", path: "/empresas/direccion-de-innovacion-financiera" },
      { titulo: "Cash management", path: "/empresas/gestion-de-caja" },
      { titulo: "Smart Salary", path: "/sueldo-inteligente" },
    ],
  },
};

const chromeEs = {
  navbarGeneral: {
    personas: "Personas",
    empresas: "Empresas",
    valor360: "Valor360",
    sueldoInteligente: "Sueldo Inteligente",
    blog: "Blog",
    quienesSomos: "¿Quiénes somos?",
    transparencia: "Transparencia",
    consumidor: "Consumidor",
  },
  navbarEmpresas: {
    beneficios: "Beneficios",
    cfoFraccional: "Innovación financiera",
    salud: "Salud",
    construccion: "Construcción",
    gestionCaja: "Gestión de caja",
    gestionAportes: "Gestión de aportes",
    cez: "CEZ",
    cezTitulo: "Consejo Empresarial del Sumapaz",
    sueldoInteligente: "Sueldo Inteligente",
    blogEmpresarial: "Blog",
    tramitesDigitales: "Trámites",
    iniciarSesion: "Iniciar sesión",
  },
  mobile: {
    ingresar: "Ingresar",
    explorar: "Explora",
    categoriasPrincipales: "Categorías principales",
    irA: "Ir a",
    masDeMeu: "Más de MEU",
    abrirMenu: "Abrir menú principal",
    cerrarMenu: "Cerrar menú",
    empresas: {
      label: "Empresas",
      description: "Soluciones de inversión y beneficios corporativos.",
      inicio: "Inicio Empresas",
      beneficios: "Beneficios",
      cfoFraccional: "Dirección de innovación financiera",
      salud: "Salud",
      construccion: "Construcción",
      gestionCaja: "Gestión de caja",
      gestionAportes: "Gestión de aportes",
      cez: "CEZ · Consejo Empresarial del Sumapaz",
      sueldoInteligente: "Sueldo Inteligente",
      blogEmpresarial: "Blog empresarial",
      tramitesDigitales: "Trámites digitales",
      cta: "Ingresar a Empresas",
    },
    common: {
      quienesSomos: "¿Quiénes somos?",
      transparencia: "Transparencia",
      consumidor: "Consumidor",
      politicaDatos: "Política de datos",
    },
  },
  footer: {
    sections: [
      {
        id: "interes",
        title: "Te puede interesar",
        items: [
          { label: "¿Quiénes somos?", path: "/quienes-somos" },
          { label: "Trabaja con nosotros", path: "/trabaja-con-nosotros" },
          { label: "Centro de ayuda", path: "/centro-de-ayuda" },
        ],
      },
      {
        id: "legal",
        title: "Legalidades",
        items: [
          { label: "Gobierno corporativo", path: "/gobierno-corporativo" },
          { label: "SARLAFT", path: "/sarlaft" },
          { label: "Protección de datos", path: "/politica-tratamiento-datos" },
          { label: "Términos y condiciones de uso", path: "/terminos-y-condiciones" },
          { label: "Tarifas", path: "/tarifas" },
          { label: "Autorización para el tratamiento de datos personales", path: "/autorizacion-tratamiento-datos" },
          { label: "Política de Resarcimiento", path: "/politica-de-resarcimiento" },
        ],
      },
      {
        id: "consumidor",
        title: "Consumidor",
        items: [
          { label: "Transparencia y acceso a la información", path: "/transparencia" },
          { label: "Atención al consumidor financiero", path: "/atencion-consumidor-financiero" },
          { label: "Defensor del consumidor financiero", path: "/defensor-consumidor-financiero" },
        ],
      },
      {
        id: "contacto",
        title: "Contáctanos",
        items: [{ label: "Carrera X" }, { label: "Bogotá +57 322 908 0554" }],
      },
      {
        id: "social",
        title: "Encuéntranos en",
        items: [
          {
            label: "Instagram",
            href: "https://www.instagram.com/meu.aliado?igsh=MTRlbDdpaG1rMDkwcg%3D%3D&utm_source=qr",
          },
          {
            label: "Facebook",
            href: "https://www.facebook.com/share/1BGeSboQxU/?mibextid=wwXIfr",
          },
          {
            label: "LinkedIn",
            href: "https://www.linkedin.com/company/meu-aliado-co/",
          },
        ],
      },
    ],
    appTitle: "Obtén nuestra App",
    appTagline: "Centralizador de información financiera y corredor de FIC, CDT y pensiones.",
    copyright: "© 2025 Todos los derechos reservados | MOU SOLUTIONS S.A.S. 901935902 -1",
  },
};

const chromeEn = {
  navbarGeneral: {
    personas: "Individuals",
    empresas: "Business",
    valor360: "Valor360",
    sueldoInteligente: "Smart Salary",
    blog: "Blog",
    quienesSomos: "About us",
    transparencia: "Transparency",
    consumidor: "Consumer",
  },
  navbarEmpresas: {
    beneficios: "Benefits",
    cfoFraccional: "Financial innovation",
    salud: "Healthcare",
    construccion: "Construction",
    gestionCaja: "Cash management",
    gestionAportes: "Contributions",
    cez: "CEZ",
    cezTitulo: "Sumapaz Business Council",
    sueldoInteligente: "Smart Salary",
    blogEmpresarial: "Blog",
    tramitesDigitales: "Procedures",
    iniciarSesion: "Sign in",
  },
  mobile: {
    ingresar: "Sign in",
    explorar: "Explore",
    categoriasPrincipales: "Main categories",
    irA: "Go to",
    masDeMeu: "More from MEU",
    abrirMenu: "Open main menu",
    cerrarMenu: "Close menu",
    empresas: {
      label: "Business",
      description: "Investment solutions and corporate benefits.",
      inicio: "Business home",
      beneficios: "Benefits",
      cfoFraccional: "Financial innovation leadership",
      salud: "Healthcare",
      construccion: "Construction",
      gestionCaja: "Cash management",
      gestionAportes: "Contribution management",
      cez: "CEZ · Sumapaz Business Council",
      sueldoInteligente: "Smart Salary",
      blogEmpresarial: "Business blog",
      tramitesDigitales: "Digital procedures",
      cta: "Sign in to Business",
    },
    common: {
      quienesSomos: "About us",
      transparencia: "Transparency",
      consumidor: "Consumer",
      politicaDatos: "Data policy",
    },
  },
  footer: {
    sections: [
      {
        id: "interes",
        title: "You may be interested in",
        items: [
          { label: "About us", path: "/quienes-somos" },
          { label: "Work with us", path: "/trabaja-con-nosotros" },
          { label: "Help center", path: "/centro-de-ayuda" },
        ],
      },
      {
        id: "legal",
        title: "Legal",
        items: [
          { label: "Corporate governance", path: "/gobierno-corporativo" },
          { label: "SARLAFT", path: "/sarlaft" },
          { label: "Data protection", path: "/politica-tratamiento-datos" },
          { label: "Terms and conditions of use", path: "/terminos-y-condiciones" },
          { label: "Fees", path: "/tarifas" },
          { label: "Authorization for personal data processing", path: "/autorizacion-tratamiento-datos" },
          { label: "Restitution policy", path: "/politica-de-resarcimiento" },
        ],
      },
      {
        id: "consumidor",
        title: "Consumer",
        items: [
          { label: "Transparency and access to information", path: "/transparencia" },
          { label: "Financial consumer support", path: "/atencion-consumidor-financiero" },
          { label: "Financial consumer ombudsman", path: "/defensor-consumidor-financiero" },
        ],
      },
      {
        id: "contacto",
        title: "Contact us",
        items: [{ label: "Carrera X" }, { label: "Bogotá +57 322 908 0554" }],
      },
      {
        id: "social",
        title: "Find us on",
        items: [
          {
            label: "Instagram",
            href: "https://www.instagram.com/meu.aliado?igsh=MTRlbDdpaG1rMDkwcg%3D%3D&utm_source=qr",
          },
          {
            label: "Facebook",
            href: "https://www.facebook.com/share/1BGeSboQxU/?mibextid=wwXIfr",
          },
          {
            label: "LinkedIn",
            href: "https://www.linkedin.com/company/meu-aliado-co/",
          },
        ],
      },
    ],
    appTitle: "Get our app",
    appTagline: "Financial information hub and broker for mutual funds, CDs, and pensions.",
    copyright: "© 2025 All rights reserved | MOU SOLUTIONS S.A.S. 901935902 -1",
  },
};

const gestionCajaShared = {
  imprevistos: [
    { affect: "ingreso", factor: [0.08, 0.18] },
    { affect: "gasto", factor: [0.06, 0.14] },
    { affect: "gasto", factor: [0.07, 0.16] },
    { affect: "ingreso", factor: [0.08, 0.2] },
    { affect: "gasto", factor: [0.05, 0.12] },
    { affect: "ingreso", factor: [0.06, 0.16] },
    { affect: "gasto", factor: [0.05, 0.12] },
    { affect: "ingreso", factor: [0.1, 0.22] },
    { affect: "gasto", factor: [0.06, 0.14] },
    { affect: "gasto", factor: [0.04, 0.1], base: "fijos" },
  ],
  shocks: [
    { affect: "ingreso", factor: [0.18, 0.32] },
    { affect: "gasto", factor: [0.14, 0.26] },
    { affect: "gasto", factor: [0.16, 0.28] },
  ],
  sensibilidadIds: ["tasasUp", "tasasDown", "ventasDown", "ventasUp"],
};

export const empresasTranslations = {
  es: {
    chrome: chromeEs,
    cfo: cfoTranslations.es,
    empresas: {
      heroTitle: "Soluciones financieras para empresas",
      heroTitleBreak: "que crecen con propósito",
      heroSubtitle: "Tesorería, dirección financiera y beneficios corporativos en un solo ecosistema.",
      cards: [
        {
          title: "Dirección de innovación financiera",
          description:
            "Acceda a dirección de innovación financiera para su empresa: planeación, indicadores, flujo de caja y apoyo en decisiones estratégicas — respaldado por la alianza MEU Aliado + Open Options.",
          buttonText: "Conocer servicio",
          path: "/empresas/direccion-de-innovacion-financiera",
        },
        {
          title: "Gestión de tesorería",
          description:
            "Optimice el manejo de excedentes de caja con alternativas de inversión corporativa. Compare condiciones y tome decisiones con respaldo financiero especializado.",
          buttonText: "Simular escenarios",
          path: "/empresas/gestion-de-caja",
        },
        {
          title: "Beneficios corporativos",
          description:
            "Fortalezca el bienestar financiero de su equipo con soluciones en pensión, aportes y herramientas que impulsan la retención y productividad de su talento.",
          buttonText: "Explorar beneficios",
          path: "/sueldo-inteligente",
        },
      ],
      banner2Text: "Impulse la gestión financiera de su organización",
      banner2Button: "Conocer dirección de innovación financiera",
      secondaryText: "Transforme la gestión financiera de su empresa con aliados estratégicos.",
      secondaryHighlight:
        "Empresas que ordenan sus finanzas toman mejores decisiones de crecimiento, inversión y talento.",
    },
    gestionCaja: {
      eyebrow: "Empresas · Tesorería",
      title: "Gestión de caja para empresas",
      subtitle:
        "Proyecte escenarios, anticipe imprevistos y comprenda cómo una gestión financiera profesional protege la operación de su empresa.",
      nav: [
        { label: "Introducción", targetId: "intro" },
        { label: "Simulador", targetId: "simulador" },
        { label: "Por qué importa", targetId: "importancia" },
        { label: "CFO", targetId: "cfo" },
      ],
      introTitle: "La caja es el pulso diario de su negocio",
      introP1:
        "Sin una visión clara de entradas, salidas y reservas, cualquier imprevisto — un cliente que paga tarde, un aumento de costos o una inversión urgente — puede comprometer meses de trabajo.",
      introP2:
        "Use el simulador para comparar qué ocurre cuando se opera sin planeación frente a un escenario con gestión de caja estructurada, similar a la que acompaña una dirección de innovación financiera.",
      riesgos: [
        "Quiebres de liquidez por falta de visibilidad del flujo de caja.",
        "Decisiones reactivas ante imprevistos operativos o comerciales.",
        "Uso ineficiente de excedentes sin proyección ni reservas.",
        "Dificultad para negociar con bancos o inversionistas sin información confiable.",
      ],
      simuladorLabel: "Herramienta interactiva",
      simuladorTitle: "Simulador de escenarios de caja",
      simuladorIntro:
        "Ingrese los números de su operación y pulse Simular escenarios. El modelo generará automáticamente imprevistos aleatorios (Monte Carlo) y escenarios de sensibilidad macroeconómica.",
      importanciaTitle: "Decisiones informadas, no reactivas",
      importanciaCards: [
        {
          titulo: "Visibilidad",
          texto: "Conozca con anticipación cuándo su caja entra en zona de riesgo y actúe antes del problema.",
        },
        {
          titulo: "Resiliencia",
          texto: "Construya colchones financieros para absorber imprevistos sin detener la operación.",
        },
        {
          titulo: "Crecimiento",
          texto: "Use excedentes con criterio para invertir, financiar oportunidades y escalar con orden.",
        },
      ],
      cfoTitle: "¿Listo para llevar la gestión de caja al siguiente nivel?",
      cfoBody:
        "La dirección de innovación financiera acompaña a su empresa con proyecciones, indicadores y escenarios reales — para que cada decisión tenga respaldo financiero.",
      cfoCta: "Conocer dirección de innovación financiera",
      cfoWhatsapp: "Solicitar asesoría",
      whatsapp:
        "https://wa.me/573213213635?text=Hola%2C%20realic%C3%A9%20el%20simulador%20de%20gesti%C3%B3n%20de%20caja%20y%20me%20gustar%C3%ADa%20agendar%20una%20asesor%C3%ADa%20sin%20costo.",
      simulador: {
        formTitle: "Cuéntenos los números de su empresa",
        formIntro:
          "Use cifras aproximadas. Al simular, generamos automáticamente cientos de escenarios aleatorios de imprevistos (simulación Monte Carlo) — usted no necesita predecir qué ni cuándo ocurrirán.",
        campos: [
          { id: "saldoInicial", label: "¿Cuánto tiene hoy en caja?", hint: "Saldo disponible para operar" },
          { id: "ingresos", label: "¿Cuánto ingresa al mes?", hint: "Ventas y cobros promedio mensuales" },
          { id: "gastosFijos", label: "¿Cuánto gasta en fijos al mes?", hint: "Nómina, arriendo, servicios, etc." },
          { id: "gastosVariables", label: "¿Cuánto gasta en variables al mes?", hint: "Insumos, comisiones, operación" },
          { id: "pagoDeuda", label: "¿Cuánto paga al mes en deuda?", hint: "Cuotas e intereses (0 si no aplica)" },
        ],
        placeholder: "Ingrese un valor en COP",
        simular: "Simular escenarios",
        resimular: "Volver a simular",
        editar: "Editar datos",
        validacion: "Complete al menos saldo en caja, ingresos mensuales y gastos fijos para simular.",
        imprevistoLabels: [
          "Retraso en cobranza",
          "Aumento de insumos",
          "Mantenimiento de emergencia",
          "Caída puntual de ventas",
          "Multa o sanción",
          "Deterioro de cartera",
          "Disrupción logística",
          "Cliente importante retrasa pago",
          "Reparación de equipos",
          "Ajuste imprevisto de nómina",
        ],
        shockLabels: ["Pérdida de contrato relevante", "Contingencia operativa mayor", "Quiebre de proveedor crítico"],
        sensibilidad: [
          {
            id: "tasasUp",
            label: "Subida de tasas (+4 pp)",
            descripcion: "Escenario adverso: costo de deuda e intereses se disparan sobre obligaciones financieras.",
          },
          {
            id: "tasasDown",
            label: "Bajada de tasas (-3 pp)",
            descripcion: "Alivio en el servicio de deuda y mejor flujo disponible.",
          },
          {
            id: "ventasDown",
            label: "Caída de ventas (-8%)",
            descripcion: "Contracción moderada de ingresos por demanda más débil o presión comercial.",
          },
          {
            id: "ventasUp",
            label: "Repunte de ventas (+10%)",
            descripcion: "Recuperación comercial con incremento moderado de ingresos.",
          },
        ],
        ...gestionCajaShared,
      },
    },
    gestionAportes: gestionAportesEs,
    productoProximamente: productoProximamenteUi.es,
  },
  en: {
    chrome: chromeEn,
    cfo: cfoTranslations.en,
    empresas: {
      heroTitle: "Financial solutions for businesses",
      heroTitleBreak: "that grow with purpose",
      heroSubtitle: "Treasury, financial leadership, and corporate benefits in one ecosystem.",
      cards: [
        {
          title: "Financial innovation leadership",
          description:
            "Access financial innovation leadership: planning, KPIs, cash flow, and strategic decision support — backed by the MEU Aliado + Open Options alliance.",
          buttonText: "Learn more",
          path: "/empresas/direccion-de-innovacion-financiera",
        },
        {
          title: "Treasury management",
          description:
            "Optimize surplus cash with corporate investment alternatives. Compare options and decide with specialized financial support.",
          buttonText: "Simulate scenarios",
          path: "/empresas/gestion-de-caja",
        },
        {
          title: "Corporate benefits",
          description:
            "Strengthen your team's financial wellbeing with pension, contribution, and retention solutions that boost productivity.",
          buttonText: "Explore benefits",
          path: "/sueldo-inteligente",
        },
      ],
      banner2Text: "Boost your organization's financial management",
      banner2Button: "Explore Financial innovation leadership",
      secondaryText: "Transform your company's financial management with strategic partners.",
      secondaryHighlight:
        "Companies that organize their finances make better growth, investment, and talent decisions.",
    },
    gestionCaja: {
      eyebrow: "Business · Treasury",
      title: "Cash management for businesses",
      subtitle:
        "Project scenarios, anticipate surprises, and see how professional financial management protects your operations.",
      nav: [
        { label: "Introduction", targetId: "intro" },
        { label: "Simulator", targetId: "simulador" },
        { label: "Why it matters", targetId: "importancia" },
        { label: "CFO", targetId: "cfo" },
      ],
      introTitle: "Cash is your business's daily pulse",
      introP1:
        "Without a clear view of inflows, outflows, and reserves, any surprise — late customer payments, cost spikes, or urgent investments — can compromise months of work.",
      introP2:
        "Use the simulator to compare operating without planning versus structured cash management, similar to what an external CFO provides.",
      riesgos: [
        "Liquidity crises from poor cash flow visibility.",
        "Reactive decisions to operational or commercial surprises.",
        "Inefficient use of surpluses without projections or reserves.",
        "Difficulty negotiating with banks or investors without reliable data.",
      ],
      simuladorLabel: "Interactive tool",
      simuladorTitle: "Cash scenario simulator",
      simuladorIntro:
        "Enter your operating numbers and click Simulate scenarios. The model automatically generates random surprises (Monte Carlo) and macroeconomic sensitivity scenarios.",
      importanciaTitle: "Informed decisions, not reactive ones",
      importanciaCards: [
        {
          titulo: "Visibility",
          texto: "Know in advance when cash enters the risk zone and act before problems arise.",
        },
        {
          titulo: "Resilience",
          texto: "Build financial cushions to absorb surprises without stopping operations.",
        },
        {
          titulo: "Growth",
          texto: "Use surpluses wisely to invest, fund opportunities, and scale with discipline.",
        },
      ],
      cfoTitle: "Ready to take cash management to the next level?",
      cfoBody:
        "Financial innovation leadership supports your company with projections, KPIs, and real scenarios — so every decision has financial backing.",
      cfoCta: "Explore Financial innovation leadership",
      cfoWhatsapp: "Request advisory",
      whatsapp:
        "https://wa.me/573213213635?text=Hello%2C%20I%20used%20the%20cash%20management%20simulator%20and%20would%20like%20to%20schedule%20a%20free%20advisory%20session.",
      simulador: {
        formTitle: "Tell us your company's numbers",
        formIntro:
          "Use approximate figures. When you simulate, we automatically generate hundreds of random surprise scenarios (Monte Carlo simulation) — you don't need to predict what or when they will happen.",
        campos: [
          { id: "saldoInicial", label: "How much cash do you have today?", hint: "Available balance to operate" },
          { id: "ingresos", label: "How much comes in per month?", hint: "Average monthly sales and collections" },
          { id: "gastosFijos", label: "How much do you spend on fixed costs?", hint: "Payroll, rent, utilities, etc." },
          { id: "gastosVariables", label: "How much on variable costs?", hint: "Supplies, commissions, operations" },
          { id: "pagoDeuda", label: "How much do you pay on debt monthly?", hint: "Installments and interest (0 if N/A)" },
        ],
        placeholder: "Enter amount in COP",
        simular: "Simulate scenarios",
        resimular: "Simulate again",
        editar: "Edit data",
        validacion: "Enter at least cash balance, monthly revenue, and fixed costs to simulate.",
        imprevistoLabels: [
          "Collection delay",
          "Input cost increase",
          "Emergency maintenance",
          "Temporary sales drop",
          "Fine or penalty",
          "Portfolio deterioration",
          "Logistics disruption",
          "Key client delays payment",
          "Equipment repair",
          "Unexpected payroll adjustment",
        ],
        shockLabels: ["Loss of major contract", "Major operational contingency", "Critical supplier failure"],
        sensibilidad: [
          {
            id: "tasasUp",
            label: "Rate hike (+4 pp)",
            descripcion: "Adverse scenario: debt service and interest costs spike on financial obligations.",
          },
          {
            id: "tasasDown",
            label: "Rate cut (-3 pp)",
            descripcion: "Relief on debt service and improved available cash flow.",
          },
          {
            id: "ventasDown",
            label: "Sales decline (-8%)",
            descripcion: "Moderate revenue contraction from weaker demand or commercial pressure.",
          },
          {
            id: "ventasUp",
            label: "Sales rebound (+10%)",
            descripcion: "Commercial recovery with moderate revenue increase.",
          },
        ],
        ...gestionCajaShared,
      },
    },
    gestionAportes: gestionAportesEn,
    productoProximamente: productoProximamenteUi.en,
  },
};
